/**
 * The world map's words (P2.12-T6, ADR-100 decision 13 and the amendment's decision 27; the design's "World map" card,
 * a visual reference), every one a draft for the author: the map's accessible name, the list's
 * heading and its marks' names, the Places button, the panel's group headings, its filter and its two short notes
 * (nothing known; P2.12-T19), the controls, the zoom buttons and the names of the levels (P2.12-T21) and the title bar's heading, the map's name and the level's (P2.12-T22), the Map button's name, the pin's confirmation, the arrow at the view's edge, the loader's
 * name for a screen reader, the float's words (P2.12-T23: Float, Dock, Close, its strip's name and the Map button's mark "Map floating"), the pop-out's (P2.12-T18: Pop out, Pop in, "Pop-up blocked" and the Map button's mark "Map popped out"), and the distances and the eight points of the compass the list speaks in.
 */
export const WORLD_MAP = {
  map: "The map of {name}",
  places: "Known places",
  placesButton: "Places",
  kind: { party: "Party", shrine: "Shrines", waypoint: "Waypoints" },
  filter: "Find a place",
  filterClear: "Clear the filter",
  filterCount: "{shown} of {total}",
  noMatch: "No place matches.",
  noneKnown: "No places are known yet.",
  shrine: "A shrine",
  waypoint: "A waypoint",
  you: "You",
  youAreHere: "You are here",
  centre: "Centre",
  clearPin: "Clear pin",
  pinSet: "Pin set",
  drawing: "Drawing the map",
  button: "Map",
  float: "Float",
  dock: "Dock",
  close: "Close",
  floatStrip: "Map controls",
  floating: "Map floating",
  popOut: "Pop out",
  popIn: "Pop in",
  popBlocked: "Pop-up blocked",
  poppedOut: "Map popped out",
  openElsewhere: "The map is open in another window.",
  zoomOut: "Zoom the map out",
  zoomIn: "Zoom the map in",
  level: { nearby: "Nearby", region: "Region", world: "World" },
  heading: "{name} \u00b7 {level}",
  tiles: { one: "{count} tile", other: "{count} tiles" },
  here: "here",
  line: "{name}, {distance} {direction}",
  hereLine: "{name}, {here}",
  elsewhere: "on another map",
  awayLine: "{name}, {away}",
  pinLine: "Pin, {distance} {direction}",
  direction: {
    north: "north",
    northEast: "north-east",
    east: "east",
    southEast: "south-east",
    south: "south",
    southWest: "south-west",
    west: "west",
    northWest: "north-west",
  },
} as const;
